module.exports = __webpack_public_path__ + "img/picture_viptc05.29d7ad73.png";